import vuexKeys from '@mixins/includes/_vuexKeys'
import notifications from "@mixins/includes/_notifications";

import MStepperBase from "@modules/steppers/m-stepper-base";
import MStepperContent from "@modules/steppers/includes/_m-stepper-content";

let baseStepper = {
    mixins: [
        notifications, vuexKeys
    ],
    components: {
        MStepperBase, MStepperContent
    },
    props: {
        name: {
            type: String,
            required: true
        }
    }
};

export default baseStepper;
